import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';
import { range } from '@/utils';
import useHasHydrated from '@/hooks/use-has-hydrated';

import Demo, { DemoSliderControl } from '@/components/Demo';

import ProfileCard from './ProfileCard';
import ProfileLoader from './ProfileLoader';

const MAX_WIDTH = 440;

function ProfileCardDemo() {
  const hasHydrated = useHasHydrated();

  return (
    <>
      <DesktopOnly>
        <Demo
          initialValues={{
            numOfCards: 3,
          }}
          controlPosition="top"
          outputWrapper={null}
          customGrid={{
            gridTemplateColumns: `min(${MAX_WIDTH}px, 100%)`,
            justifyContent: 'center',
          }}
          controls={[
            <DemoSliderControl
              id="numOfCards"
              key="numOfCards"
              name="numOfCards"
              label="Number of Profiles"
              min={1}
              max={6}
            />,
          ]}
        >
          {({ numOfCards }) => {
            const loaderHeight = numOfCards === 3 ? 420 : 305;
            const loaderHeightRem = `${loaderHeight / 16}rem`;
            return (
              <Wrapper data-num-of-cards={numOfCards}>
                {range(numOfCards).map((num) =>
                  hasHydrated ? (
                    <CardWrapper key={`card-${num}`}>
                      <ProfileCard />
                    </CardWrapper>
                  ) : (
                    <ProfileLoader
                      key={`loader-${num}`}
                      style={{ height: loaderHeightRem }}
                    />
                  )
                )}
              </Wrapper>
            );
          }}
        </Demo>
      </DesktopOnly>
      <MobileFallback>
        <Image
          loading="lazy"
          alt="A grid of profile cards with two rows. The first row has 3 cards, and each card uses the 'narrow' layout. The second row has 2 cards, and each card uses the 'wide' layout."
          src="/images/container-queries/card-grid-demo.png"
        />
      </MobileFallback>
    </>
  );
}

const DesktopOnly = styled.div`
  @media ${BREAKPOINTS.mdAndSmaller} {
    display: none;
  }
`;
const MobileFallback = styled.div`
  display: none;
  @media ${BREAKPOINTS.mdAndSmaller} {
    display: block;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`;

const CardWrapper = styled.div`
  flex: 1;
  min-width: 13rem;
  max-width: 29.325rem;
  margin-inline: auto;
  container-type: inline-size;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 1299 / 1394;
  border-radius: 4px;
  margin-bottom: 32px;
`;

export default ProfileCardDemo;
